/**
 * Displays a fallback UI with meaningful message to users in error situations
 *
 * @module
 * @category Component
 */

import 'BomdisoftComponents/fallback/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';

type FallbackProps = {
  message?: string;
  showIcon?: boolean;
  className?: string;
};

export const Fallback = ({ message = '', showIcon = true, className }: FallbackProps) => (
  <div className={joinClasses('bomdisoft-fallback', className)}>
    {showIcon && <p aria-hidden='true' className='bomdisoft-fallback-icon' data-testid='fallback-icon' />}
    <p className='bomdisoft-fallback-info'>{message}</p>
  </div>
);
